import { useAtom } from '@reatom/npm-react'

import { environmentAtom } from '../environment'

export const useAssetsUrlBuilder = () => {
  const [env] = useAtom((ctx) => ctx.spy(environmentAtom).assets)

  return {
    customEmojiWebmUrl: (id: string) => `${env.customEmojiHost}/${id}.webm`,
    customEmojiPngUrl: (id: string) => `${env.customEmojiStaticHost}/${id}.png`,
    currencyIconUrl: (logo: string) =>
      checkForAbsoluteLink(logo, `${env.tokenLogosHost}/${logo}`),
    // avatarUrl: (delugeId: DelugeId) => `${env.avatarsHost}/${delugeId}.jpg`,
    commentAttachmentUrl: (id: string) =>
      checkForAbsoluteLink(id, `${env.commentAttachmentsHost}/${id}`),
  }
}

const checkForAbsoluteLink = (str: string, fallback: string) => {
  if (str.startsWith('http://') || str.startsWith('https://')) {
    return str
  }
  return fallback
}
